import React from "react";
import { ReactComponent as ChatGold } from "../../../../assets/icon/chat-gold.svg";
import { ReactComponent as Telephone } from "../../../../assets/icon/telephone.svg";
import { useConfig } from "../../../../providers/config";

import cln from "classnames";

const ContactUs = () => {
  const config = useConfig();
  const companyPhoneNumber = config.companyPhoneNumber;
  const cleanedPhoneNumber = companyPhoneNumber.replace(/\D/g, "");

  return (
    <div className="flex flex-col gap-2">
      <div className={cln("font-bold text-[1.0625rem]")}>Связаться с нами</div>
      <div className="flex justify-between items-center h-[60px] gap-3 md:gap-4">
        <a
          href={`https://api.whatsapp.com/send/?phone=${cleanedPhoneNumber}`}
          className="flex items-center justify-center rounded-2xl h-full w-full px-3 py-1 bg-gray-100"
        >
          <ChatGold />
          <span className="ml-2 text-sm font-medium">Написать в WhatsApp</span>
        </a>

        <a
          href={`tel:${companyPhoneNumber}`}
          className="flex items-center justify-center rounded-2xl h-full w-full px-3 py-1 bg-gray-100"
        >
          <Telephone />
          <span className="ml-2 text-sm font-medium">По телефону</span>
        </a>
      </div>
    </div>
  );
};

export default ContactUs;
